/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrowserProfileDto } from '../models/BrowserProfileDto';
import type { ProxySettingsBody } from '../models/ProxySettingsBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreatorProxySettingsRestEndpointService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getProxySettings({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator/{creatorId}/proxy',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * @returns BrowserProfileDto OK
     * @throws ApiError
     */
    public static setProxySettings({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ProxySettingsBody,
    }): CancelablePromise<BrowserProfileDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/{creatorId}/proxy',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
